<template>
  <div class="goodsDetail">
    <LinkTitle />

    <div class="goodsDetailBox">
      <PageSearchTitle :title="renderTitle" :hideCart="true"></PageSearchTitle>
      <div v-if="$route.query.type == -1">
        <div class="goodsDetailUp">
          <div class="goodsDetailLeft">
            <div class="goodsDetailLeftTitleImgBox">
              <el-image
                v-if="bigImgCurrentUrl"
                :lazy="true"
                fit="cover"
                class="goodsDetailLeftTitleImg"
                :src="getImageUrl(bigImgCurrentUrl, 'o')"
              />
              <div v-else class="goodsDetailLeftTitleImg"></div>
            </div>
            <div class="goodsDetailLeftTitleImgItemBox">
              <div v-for="(item, index) in images.slice(0, 4)" :key="index">
                <el-image
                  @mouseover="monseoverImgItem(item)"
                  class="goodsDetailLeftTitleImgItem"
                  :src="getImageUrl(item)"
                  fit="cover"
                ></el-image>
              </div>
            </div>
          </div>
          <div class="goodsDetailCenter">
            <div class="goodsDetailCenterTitle">{{ goods.name }}</div>
            <div class="goodsDetailCenterTitleTips"></div>
            <div class="goodsDetailCenterItem">
              <div class="goodsDetailCenterLeft">价格</div>

              <span class="goodsDetailCenterPriceNum">&yen;</span>
              <span class="goodsDetailCenterPriceNum">{{
                goods.price && goods.price.toFixed(2)
              }}</span>
            </div>
            <div class="goodsDetailCenterItem">
              <div class="goodsDetailCenterLeft">分类</div>
              <span class="goodsDetailCenterPriceSingo">{{
                goods.goodsType
              }}</span>
            </div>
            <div class="goodsDetailCenterItem">
              <div class="goodsDetailCenterLeft">品种</div>
              <span class="goodsDetailCenterPriceSingo">{{ goods.breed }}</span>
            </div>
            <div class="goodsDetailCenterItem">
              <div class="goodsDetailCenterLeft">库存</div>
              <span class="goodsDetailCenterPriceSingo"
                >{{ goods.stockCount }}{{ goods.buyUnit }}</span
              >
            </div>
            <div class="goodsDetailCenterItem">
              <div class="goodsDetailCenterLeft">数量</div>

              <el-input-number
                v-model="num"
                controls-position="right"
                @change="handleChange"
                @blur="onBlur"
                size="mini"
                :min="goods.minBuyCount"
                :max="goods.stockCount"
                label="描述文字"
              ></el-input-number>
            </div>

            <div class="goodsDetailCenterButtons">
              <div
                @click="buyNow"
                class="goodsDetailCenterButtonsItem goodsDetailCenterButtonsItemLeft"
              >
                <span>立即购买</span>
              </div>
              <!-- <div @click="checkLogin(userInfo&&userInfo.access_token)" class="goodsDetailCenterButtonsItem"> -->
              <div @click="addCart" class="goodsDetailCenterButtonsItem">
                <i class="el-icon-shopping-cart-2"></i>
                <span class="goodsDetailCenterButtonsItemCartBox"
                  >加入购物车</span
                >
              </div>
            </div>
          </div>
          <div class="goodsDetailRight">
            <StoreInfo
              v-if="showStoreInfo"
              :storeId="goods.storeId"
              :border="{ 'border-bottom': '1px solid #e5e5e5' }"
              :storeName="goods.storeName"
            
            ></StoreInfo>
          </div>
        </div>
        <div class="goodsDetailDown">
          <div class="goodsDetailDownLeft">
            <div class="goodsDetailDownLeftone">
              <!-- <StoreInfo :storeName='goods.storeName'></StoreInfo> -->
            </div>
          </div>
          <div class="goodsDetailDownCenter">
            <el-tabs type="border-card">
              <el-tab-pane label="商品详情">
                <div class="goodsDetailTabsContaier">
                  <GoodsProperty
                    :type="$route.query.type"
                    :goodsInfo="goods"
                  ></GoodsProperty>
                  <div v-if="images" class="descImgs gxImgBox">
                    <div v-for="(item, index) in images" :key="index">
                      <el-image
                        class="goodsDetailLeftTitleImgItemBig"
                        :src="getImageUrl(item, 'o')"
                        fit="cover"
                      ></el-image>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="累计评价">
                <Comments :goodsId="goodsId"></Comments>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="goodsDetailDownRight">
            <!-- <StoreInfo :storeName='goods.storeName'></StoreInfo> -->
          </div>
        </div>
      </div>

      <div class="gxGoods" v-else-if="$route.query.type == 1">
        <GoodsProperty
          :type="$route.query.type"
          :goodsInfo="goods"
          :index="$route.query.index"
        ></GoodsProperty>
        <div class="gxBottomBox">
          <div class="storeInfoRight">
            <StoreInfo
              v-if="showStoreInfo"
              :hideStore="true"
              :storeId="goods.storeId"
              :border="{ 'border-bottom': '1px solid #e5e5e5' }"
              :storeName="goods.storeName"
                :num='6'
            ></StoreInfo>
          </div>
          <div v-if="images" class="descImgs">
            <div v-for="(item, index) in images" :key="index">
              <el-image
                class="goodsDetailLeftTitleImgItemBig"
                :src="getImageUrl(item, 'o')"
                fit="cover"
              ></el-image>
            </div>
          </div>
        </div>
      </div>


        <div class="gxGoods" v-else-if="$route.query.type == 2">
        <GoodsProperty
          :type="$route.query.type"
          :goodsInfo="goods"
           :index="$route.query.index"
        ></GoodsProperty>

          <div class="storeInfoRight3">
            <StoreInfo
              v-if="showStoreInfo"
              :hideStore="true"
              :storeId="goods.storeId"
              :border="{ 'border-bottom': '1px solid #e5e5e5' }"
              :storeName="goods.storeName"
                :num='7'
            ></StoreInfo>
          </div>
   
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import GoodsProperty from "./component/GoodsProperty";
import Comments from "./component/Comments";
import PageSearchTitle from "@/components/components/PageSearchTitle";
import StoreInfo from "@/components/components/StoreInfo";
import { mapActions, mapState, mapMutations } from "vuex";
import {
  queryGoodsDetailUrl,
  getEvaluateMsgListUrl,
  getImageUrl,
  appDownLoadUrl,
  getGqProductDetail,
  getDate,
} from "@/api/api";
// import city from "@/utils/city";
// addrId: 110101;
// address: "北京";
// avgWeight: 0;
// birthPlace: "110000";
// birthType: 1;
// breed: "仔猪,外三元仔猪,";
// buyUnit: "箱";
// coverPlan: "group1/M00/00/01/wKjKBFzaMWOEU8KyAAAAAMED9f8003.jpg";
// empId: "10000010";
// empName: "胡云飞";
// goodsType: "白条";
// grade: 2;
// id: "309f39b1b575470ab1d438a48102b70e";
// image: "group1/M00/00/07/wKjKBF1yWo2EIILFAAAAAHAYnOM417.jpg";
// kind: 2;
// minBuyCount: 10;
// name: "三级分类测试";
// orderPrice: 10;
// payDays: 0;
// price: 1;
// remark: "书";
// sale_number: 0;
// spec: "一元已投";
// status: 1;
// stockCount: 118;
// storeGrade: 1;
// storeId: "4a686a2ba38e469488299de11121a046";
// storeName: "小飞公司";
// tags: null;
// topNo: 0;
// types: "050,080,";
// unit: "头";
// unitWeight: 10;
// userId: "10000010";
// weightValue: 0;

// http://localhost:8080/mall/goodsDetail?type=-1&goodsId=309f39b1b575470ab1d438a48102b70e

export default {
  data() {
    return {
      type: "",
      goodsId: "",
      goods: {},
      comments: [],
      commentsCount: {},
      loading: false,
      pageSize: 5,
      index: -1,
      show: true,
      num: 1,
      images: "",
      bigImgCurrentUrl: "",
      imagesArr: "",
      showStoreInfo: true,
    };
  },

  props: ["gid"],
  components: {
    GoodsProperty,
    Comments,
    PageSearchTitle,
    StoreInfo,
  },
  watch: {
    "$route.query": function () {
      this.getIsWxClient();
      this.initData();
    },
  },
  created() {
    this.getImageUrl = getImageUrl;
    this.getDate = getDate;
    this.getIsWxClient();
    this.initData();
  },
  methods: {
    ...mapMutations([
      "saveUserInfo",
      "setLoginInfo",
      "saveCompanyInfo",
      "addCartList",
      "changeCartListStoreItem",
      "changeCartListAllToCheckedFalse",
      "deleteCartList",
    ]),
    onBlur(e) {
      let value = e.target.value;
      value = parseInt(value);
      this.num = value;
    },
    buyNow() {
      if (this.goods.stockCount >= this.goods.minBuyCount) {
        //现将其他的选中项切换成未选中项,然后删除这个商品在购物车里的信息,再添加购物车进购物车
        this.changeCartListAllToCheckedFalse();
        this.deleteCartList(this.goods);
        this.addCartList({ ...this.goods, _buyNum: this.num });

        this.$checkLogin(this.userInfo)
          .then((res) => {
            // alert(res)
            this.$router.push("creatOrder");
          })
          .catch(() => {
            this.$router.push("login");
          });
      } else {
        this.$alert("库存不足", "", { center: true, showClose: false });
      }
    },
    addCart() {
      let { name, query } = this.$route;
      console.log("this.userInfo:", this.userInfo);
      this.$checkLogin(this.userInfo)
        .then(() => {
          this.addCartList({ ...this.goods, _buyNum: this.num });
        })
        .catch(() => {
          this.setLoginInfo({ name, query });
          this.$router.push({ name: "login" });
        });
      // console.log(global)
      // return
      // global.checkLogin()
      // .then(res => {
      //   console.log(res);
      // })
      // .catch(err => {
      //   console.log(err);
      // });
    },
    getIsWxClient() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.show = true;
        return false;
      }
      this.show = false;
      return true;
      console.log(this.showTips);
    },
    setType() {
      let { type, goodsId } = this.$route.query;
      this.type = type;
      this.goodsId = goodsId;
    },
    handleChange() {},
    initData() {
      this.setType();
      let that = this;
      let url = this.type == -1 ? queryGoodsDetailUrl : getGqProductDetail;
      let data =
        this.type == -1 ? { gid: that.goodsId } : { sdId: that.goodsId };
      let param = new URLSearchParams();
      for (var k in data) {
        param.append(k, data[k]);
      }
      this.$axios({
        method: "post",
        data: param,
        url,
      })
        .then((res) => {
          console.log("res11", res);
          if (res.data.resultCode == 1) {
            let goods = res.data.data;
            let images = "";
            if (goods.coverPlan && goods.image) {
              images = goods.coverPlan + "," + goods.image;
            } else if (!goods.coverPlan && goods.image) {
              images = goods.image;
            } else if (goods.coverPlan && !goods.imag) {
              images = goods.coverPlan;
            }

            this.goods = goods;
            this.num = goods.minBuyCount;
            console.log("images", images);
            images = images.split(",");
            this.images = images;
            console.log("images[0]", images[0]);
            this.bigImgCurrentUrl = images[0];
            // alert(1)

            this.showStoreInfo = false;
            setTimeout(() => {
              this.showStoreInfo = true;
            }, 100);
          } else {
            this.$alert(res.data.resultMsg, "", {
              center: true,
              showClose: false,
            });
          }
        })
        .catch((err) => {
          this.$alert(JSON.stringify(err), "", { center: true, showClose: false });
        });
    },
    monseoverImgItem(item) {
      console.log(item);
      this.bigImgCurrentUrl = item;
    },
    onImageErr(e) {
      console.log("加载失败");
      console.log(e);
      //  alert(this.bigImgCurrentUrl)
      e.path[0].image = getImageUrl(this.bigImgCurrentUrl);
    },
    onImageLoadSuccess(e) {
      console.log("加载成功");
      console.log(e);
    },
    openApp() {
      if (this.getIsWxClient()) {
        let { type, goodsId } = this.$route.query;
        window.location.href = `myapp://jp.app/openwith?type=${type}&goodsId=${goodsId}`; //-1普通商品,1是供应，2是需求
      }
    },
    downLoadApp() {
      window.location.href = appDownLoadUrl;
    },
    getCity(areaId) {
      let value = "国外";
      city.forEach(function (item, index) {
        if (areaId == item.value) {
          value = item.label;
          return;
        }
      });
      return value;
    },
  },
  computed: {
    ...mapState(["userInfo"]),
    renderTitle() {
      if (this.$route.query.type == -1) {
        return "";
      } else if (this.$route.query.type == 1) {
        return "供应商品";
      }else if (this.$route.query.type == 2) {
        return "求购商品";
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@media screen and(min-width:320px) and (max-width: 1200px) {
  .goodsDetailBox {
    padding: 0 10px !important;
  }
}

.title {
  text-align: center;
  font-size: 16px;
  color: #666;
  height: 40px;
  line-height: 40px;
  background-color: #f6f6f6;
}

.goodsPicsSwipe {
  max-height: 200px;
  background-color: #fff;
}
.goodsDetail {
  background-color: #fff;
  font-size: 14px;
  color: #666;
}
.goodsDetailName {
  display: flex;
  align-items: center;
  font-size: 16px;
  background-color: #fff;
}
.goodsDetailStoreNameText {
  font-size: 12px;
}
.goodsDetailStoreName {
  background-color: #fff;
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 5px;
  color: #858585;
  display: flex;
  align-items: center;
}
.goodsDetailPrice {
  color: #da0e19;
  font-size: 14px;
  background-color: #fff;
}
.goodsDetailProps {
  background-color: #fff;
  overflow: hidden;
  margin-top: 5px;
  margin-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
}
.propsItem {
  float: left;
  width: 50%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 12px;
  margin-top: 4px;
  margin-bottom: 4px;
  padding-right: 5px;
  box-sizing: border-box;
  color: #858585;
}
.goodsMark {
  margin-top: 5px;
  margin-bottom: 5px;
  background-color: #fff;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  padding-left: 10px;
  padding-right: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.comment {
  padding: 5px;
  background-color: #fff;
}
.comment_title {
  height: 40px;
  line-height: 40px;
}
.comment_type_button {
  margin-left: 5px;
}
.comment_type_button_text {
  color: #666 !important;
}
.commentUserImg {
  width: 30px;
  height: 30px;
  border-radius: 30px;
  margin-right: 10px;
}
.comments_title {
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.comments_title_left {
  display: flex;
  align-items: center;
}
.item_content {
  padding-left: 5px;
}
.footer {
  position: fixed;
  bottom: 0;
  height: 60px;
  line-height: 60px;
  font-size: 16px;
  text-align: center;
  display: flex;
  width: 100%;
  color: #fff;
}
.openAppButton {
  flex: 1;
  background-color: #fda492;
  width: 100%;
}
.downLoadAppButton {
  flex: 1;
  background-color: #ff4423;
  width: 100%;
}
.titleImgItems {
  width: 100%;
}
.pop_image {
  width: 100%;
  position: relative;
  left: 10%;
}

.goodsDetailNameSpan {
  background-color: skyblue;
  padding: 0 5px;
  border-radius: 5px;
  color: white;
  font-size: 14px;
  position: relative;
  left: -5px;
}
.remark {
  overflow: hidden;
  background-color: #fff;
  margin-bottom: 5px;
  padding: 5px 10px;
}

.goodsDetailUp {
  height: 480px;
  margin-left: 100px;
  margin-right: 100px;
  background-color: #fff;
  display: flex;
  border: 1px solid #e5e5e5;
}
.goodsDetailLeft {
  height: 480px;
  width: 280px;
  background-color: #fff;
  border-top: none;
  border-right: 1px solid #f1f1f1;
}
.goodsDetailCenter {
  flex: 1;
  margin: 30px 20px 0px 30px;
  background-color: #fff;
  position: relative;
}
.goodsDetailRight {
  height: 480px;
  width: 280px;
  background-color: #fff;
  border-top: none;
  border-left: 1px solid #e6e6e6;
}
.goodsDetailLeftTitleImgBox {
  text-align: center;
  height: 400px;
}
.goodsDetailLeftTitleImg {
  width: 280px;
  height: 400px;
  border-bottom: 1px solid #f1f1f1;
}
.goodsDetailLeftTitleImgItem {
  height: 60px;
  width: 60px;
  border: 2px solid #fff;
  margin: 0 5px;
  box-sizing: border-box;
}
.goodsDetailLeftTitleImgItem:hover {
  border-color: #f40;
}
.goodsDetailLeftTitleImgItemBox {
  background-color: #f9f9f9;
  height: 80px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.goodsDetailCenterTitle {
  font-size: 16px;
  color: "#333";
  font-weight: 700;
  padding-left: 5px;
}
.goodsDetailCenterTitleTips {
  padding-left: 5px;
  font-size: 14px;
  height: 20px;
}
.goodsDetailCenterLeft {
  width: 50px;
  display: inline-block;
}
.goodsDetailCenterItem {
  margin: 5px 0;
  font-size: 14px;
  height: 20px;
  line-height: 22px;
  color: #666;
}
.goodsDetailCenterPriceNum {
  color: #f40;
  font-size: 18px;
}
.goodsDetailCenterNum {
  display: flex;
  flex-direction: "row";
  height: 50px;
  align-items: center;
}
.goodsDetailCenterNumLeft {
  margin-right: 20px;
}
.goodsDetailCenterButtons {
  background-color: #fff;
  height: 40px;
  display: flex;

  align-content: center;
  box-sizing: border-box;
  width: 400px;
  margin-top: 30px;
}

.goodsDetailCenterButtonsItem {
  width: 160px;
  background-color: #f40;
  color: #fff;
  display: flex;
  justify-content: center;
  border: 1px solid #f40;
  box-sizing: border-box;
  align-items: center;
  border-radius: 2px;
}
.goodsDetailCenterButtonsItemLeft {
  background-color: #ffe4d0;
  color: #e5511d;
  border-color: #f0cab6;
  margin-right: 20px;
}
.goodsDetailCenterButtonsItem:hover {
  cursor: pointer;
}
.goodsDetailCenterButtonsItemCartBox {
  margin-left: 10px;
}

.goodsDetailDown {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
.goodsDetailDownLeft,
.goodsDetailDownRight {
  width: 200px;
  background-color: #fff;
}
.goodsDetailDownCenter {
  flex: 1;
}
.descImgs {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  // background-color: #fff;
}
.goodsDetailTabsContaier {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.goodsDetailLeftTitleImgItemBig {
  width: 550px;
}
.stepper {
}
.goodsDetailBox {
  padding: 0 150px;
  min-width: 1000px;
}
.tips {
  margin-top: 10px;
}
.gxGoods {
  max-width: 1000px;
  margin: 0 auto;
  margin-top: 20px;
  background-color: #fff;
  // background-color: #f9f9f9;
  // border: 1px dashed #f60;
  padding: 10px;
}
.gxImgBox {
  margin-top: 20px;
}
.storeInfoRight {
  width: 150px;
  position: absolute;
  top: 0px;
  left: 20px;
  z-index: 99;
}
.storeInfoRight1{
 width: 150px;
  position: absolute;
  top: 0px;
  right: 20px;
  z-index: 99;
}
.storeInfoRight3{
  margin:0 auto;
  max-width: 1000px;
  margin-top: 100px;
}
.gxBottomBox {
  display: flex;
  flex-direction: row;
  justify-content: center;
  position: relative;
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/GoodsDetail/GoodsDetail.vue